import { AlertUtil } from './../utils/alert-util';
import { AggiudicatarioService } from './../services/aggiudicatario.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig, MenuItem } from 'primeng/api';
import { IAggiudicatario } from '../interfaces/IAggiudicatario';
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import * as Constants from '../utils/constants'
import { Util } from '../utils/util';
import * as Enum from '../utils/enums'
import { DocumentiService } from '../services/documenti.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-aggiudicatario-modal',
  templateUrl: './aggiudicatario-modal.component.html',
  styleUrls: ['./aggiudicatario-modal.component.css']
})
export class AggiudicatarioModalComponent implements OnInit {

  @ViewChild('op') op: OverlayPanel

  aggiudicatarioForm: FormGroup
  aggiudicatarioForUpdate: IAggiudicatario
  statiAntimafia: any[]
  selectedStato: string
  usernamePattern = "^[a-zA-Z0-9-_.!-]*$";
  isUpdate: boolean = false
  fromFiliera: boolean = false
  uploadedFile: any //for upload file
  fileName: string  // name of file already uploaded
  attachmentUrl: string = ""                  // url dell'allegato
  itemsAllegato: MenuItem[];


  constructor(private formBuilder: FormBuilder,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private aggiudicatarioService: AggiudicatarioService,
    private documentiService: DocumentiService,
    private translate: TranslateService,
    private alertUtil: AlertUtil) {
    this.fromFiliera = this.config.data.fromFiliera
    this.aggiudicatarioForUpdate = this.config.data.aggiudicatario
    this.fileName = this.aggiudicatarioForUpdate && this.aggiudicatarioForUpdate.CertificatoAntimafia ? this.aggiudicatarioForUpdate.CertificatoAntimafia.Nome : null

    if (this.config.header == 'Modifica aggiudicatario') {
      this.isUpdate = true
    }


    this.setStatoAntimafia()

    //build form group
    this.aggiudicatarioForm = this.formBuilder.group({
      'username': [{value:'',disabled: this.isUpdate}, Validators.required],//disabled field in update mode
      'ragioneSociale': ['', Validators.required],
      'partitaIva': ['', Validators.required],
      'codFiscale': [''],
      'nazione': [''],
      'provincia': [''],
      'comune': [''],
      'codIstat': [''],
      'indirizzo': [''],
      'cap': [''],
      'email': [''],
      'telefono': [''],
      'fax': [''],
      'inail': [''],
      'cassaEdile': [''],
      'statoAntimafia': [{value:'',disabled: true}]
    })

    if (this.aggiudicatarioForUpdate != null) {
      this.setFormValueForUpdate()
    }
  }

  ngOnInit() {
    this.selectedStato = "In attesa di verifica"
  }

  // convenience getter for easy access to form fields
  get form() { return this.aggiudicatarioForm.controls; }

  onSubmit() {
    if (this.aggiudicatarioForm.valid) {
      //retrieve values from form
      let username = this.aggiudicatarioForm.controls['username'].value
      let ragioneSociale = this.aggiudicatarioForm.controls['ragioneSociale'].value
      let partitaIva = this.aggiudicatarioForm.controls['partitaIva'].value
      let codFiscale = this.aggiudicatarioForm.controls['codFiscale'].value
      let nazione = this.aggiudicatarioForm.controls['nazione'].value
      let provincia = this.aggiudicatarioForm.controls['provincia'].value
      let comune = this.aggiudicatarioForm.controls['comune'].value
      let codIstat = this.aggiudicatarioForm.controls['codIstat'].value
      let indirizzo = this.aggiudicatarioForm.controls['indirizzo'].value
      let cap = this.aggiudicatarioForm.controls['cap'].value
      let email = this.aggiudicatarioForm.controls['email'].value
      let telefono = this.aggiudicatarioForm.controls['telefono'].value
      let fax = this.aggiudicatarioForm.controls['fax'].value
      let inail = this.aggiudicatarioForm.controls['inail'].value
      let cassaEdile = this.aggiudicatarioForm.controls['cassaEdile'].value
      let statoAntimafia = this.aggiudicatarioForm.controls['statoAntimafia'].value


      //build aggiudicatario
      let aggiudicatarioObj: IAggiudicatario = {
        Username: username,
        Ragione_sociale: ragioneSociale,
        Partita_IVA: partitaIva,
        Codice_fiscale: codFiscale,
        Nazione: nazione,
        Provincia: provincia,
        Comune: comune,
        Codice_ISTAT: codIstat,
        Indirizzo: indirizzo,
        CAP: cap,
        Email: email,
        Telefono: telefono,
        Fax: fax,
        Inail: inail,
        Cassa_edile: cassaEdile,
        Stato_antimafia: statoAntimafia
      }

      this.callSaveAggiudicatario(aggiudicatarioObj)
    }
  }

  /**
   * create or update aggiudicatario
   * @param aggiudicatarioObj aggiudicatarioObj
   */
  callSaveAggiudicatario(aggiudicatarioObj: IAggiudicatario) {
    //create or update aggiudicatario
    Loading.isLoading = true
    if (this.aggiudicatarioForUpdate) {
      aggiudicatarioObj.Id = this.aggiudicatarioForUpdate.Id
    }
    let reqBuilder = new RequestBuilder(aggiudicatarioObj)
    this.aggiudicatarioService.save(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.alertUtil.showAlert("LBL_AGGIUDICATARIO_SAVE_SUCCESS", null, null, null, () => {
            this.ref.close(aggiudicatarioObj)
          })
        } else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }

      },
      error => {
        let errorKey ="LBL_HTTP_ERROR_0"
        if(error.status){
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey, null, null, null, () => {
          this.ref.close(error)
        })
      }
    )
  }

  /**
   * set form field when mode is update
   */
  setFormValueForUpdate() {
    this.aggiudicatarioForm.controls['username'].setValue(this.aggiudicatarioForUpdate.Username)
    this.aggiudicatarioForm.controls['ragioneSociale'].setValue(this.aggiudicatarioForUpdate.Ragione_sociale)
    this.aggiudicatarioForm.controls['partitaIva'].setValue(this.aggiudicatarioForUpdate.Partita_IVA)
    this.aggiudicatarioForm.controls['codFiscale'].setValue(this.aggiudicatarioForUpdate.Codice_fiscale)
    this.aggiudicatarioForm.controls['nazione'].setValue(this.aggiudicatarioForUpdate.Nazione)
    this.aggiudicatarioForm.controls['provincia'].setValue(this.aggiudicatarioForUpdate.Provincia)
    this.aggiudicatarioForm.controls['comune'].setValue(this.aggiudicatarioForUpdate.Comune)
    this.aggiudicatarioForm.controls['codIstat'].setValue(this.aggiudicatarioForUpdate.Codice_ISTAT)
    this.aggiudicatarioForm.controls['indirizzo'].setValue(this.aggiudicatarioForUpdate.Indirizzo)
    this.aggiudicatarioForm.controls['cap'].setValue(this.aggiudicatarioForUpdate.CAP)
    this.aggiudicatarioForm.controls['email'].setValue(this.aggiudicatarioForUpdate.Email)
    this.aggiudicatarioForm.controls['telefono'].setValue(this.aggiudicatarioForUpdate.Telefono)
    this.aggiudicatarioForm.controls['fax'].setValue(this.aggiudicatarioForUpdate.Fax)
    this.aggiudicatarioForm.controls['inail'].setValue(this.aggiudicatarioForUpdate.Inail)
    this.aggiudicatarioForm.controls['cassaEdile'].setValue(this.aggiudicatarioForUpdate.Cassa_edile)
    this.aggiudicatarioForm.controls['statoAntimafia'].setValue(this.aggiudicatarioForUpdate.Stato_antimafia)
  }

  setStatoAntimafia() {
    this.statiAntimafia = Constants.STATI_ANTIMAFIA
  }

  /**
   * control of whitespace
   * @param control form control
   */
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

    /**
  * callback fired when file is uploaded
  * @param event file
  * @param upload 
  */
    uploadClick(event: any, upload: any) {
      this.uploadedFile = null
      upload.clear()
      if (event.files) {
        this.uploadedFile = event.files[0];
        this.fileName = this.uploadedFile.name
      }
    }

      /**
   * 
   * @param menu 
   * @param event
   */
  openMenu(menu, event) {
    this.optionsAllegato(event)
    menu.toggle(event)
  }

    /**
   * set options allegato
   * @param event 
   */
    private optionsAllegato(event: any) {
      this.translate.get(["LBL_ALLEGATO_APRI", "LBL_ALLEGATO_CANCELLA",]).subscribe(res => {
        this.itemsAllegato = [
          {
            label: res["LBL_ALLEGATO_APRI"], icon: 'pi pi-download', command: () => {
              this.openAllegato(event);
            }
          }
        ]
      })
    }


  /**
   * open allegato in other tab
   */
  openAllegato(event: any) {
    let requestBuilder = new RequestBuilder({
      IdCertificato: this.aggiudicatarioForUpdate.CertificatoAntimafia.Id,
      IdAzienda: this.aggiudicatarioForUpdate.Id
    })
    Loading.isLoading = true
    this.documentiService.downloadCertificatoAntimafia(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response && response["error"] == null) {
          //check allegato extension
          let allegatoType = this.aggiudicatarioForUpdate.CertificatoAntimafia.Estensione.trim()
          let allegatoNome = this.aggiudicatarioForUpdate.CertificatoAntimafia.Nome
          if (!allegatoType) {
            allegatoType = allegatoNome.substring(allegatoNome.lastIndexOf("."));
          }
          if (allegatoType == Enum.FILE_TYPE_ENUM.PDF) {
            Util.showPdf(response)
          } else if (allegatoType == Enum.FILE_TYPE_ENUM.JPEG || allegatoType == Enum.FILE_TYPE_ENUM.JPG
            || allegatoType == Enum.FILE_TYPE_ENUM.PNG) {
            this.attachmentUrl = "data:image/" + allegatoType + ";base64," + response
            //Apertura dell'overlay panel
            this.op.toggle(event)

          } else {
            Util.downloadFile(response, allegatoType, allegatoNome)
          }
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + JSON.stringify(response.error.Stack))
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )
  }

    /**
   * determines whether save button is disabled
   */
    isDisabledButton(): boolean {
      let isDisabled: boolean = true
  
      if (this.uploadedFile && this.fileName) {
        isDisabled = false
      }
  
      return isDisabled
    }
}
